import { RouteConfig } from 'vue-router';
import Overview from '@/views/damagecases/Overview.vue';
import PaymentOverview from '@/views/damagecases/PaymentOverview.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/damagecases/',
		name: 'damagecases',
		component: Overview,
	},
	{
		path: '/damagecases/:id/',
		name: 'damagecases.edit',
		// TODO remove this after all links are set
		redirect: to => {
			return { name: 'management.process.edit', params: { customer: '0', processId: to.params.id } };
		},
	},
	{
		path: '/payments/',
		name: 'payment',
		component: PaymentOverview,
	},
];

export default routes;
